import {
  type ItemPrice,
  type ItemPrices,
} from '@/types/productSelectionAndCheckout/types';
import {
  type RxPurchaseContextPrices,
  type PurchaseContext,
} from '@/types/purchaseContextToggle/types';

export const getRxItemId = (rxCard: { id: string | number }) =>
  Number(rxCard.id);

export const getRxPurchaseContextPricesFromAnyItemPrices = (
  rXItemId: number,
  itemPricesArgs: Partial<Record<PurchaseContext, ItemPrices>>,
) =>
  Object.entries(itemPricesArgs).reduce<RxPurchaseContextPrices>(
    (output, [key, itemPrices]) => {
      if (itemPrices?.[rXItemId] !== undefined) {
        output[key as PurchaseContext] = itemPrices[rXItemId];
      }
      return output;
    },
    {},
  );

export const getRxPurchaseContextPrice = (
  rxPurchaseContextPrices: Partial<Record<PurchaseContext, ItemPrice>>,
  context: PurchaseContext,
): ItemPrice => {
  const itemPrice = rxPurchaseContextPrices[context];

  if (itemPrice) {
    return itemPrice;
  } else {
    const fallback = Object.values(rxPurchaseContextPrices)[0];
    if (!fallback) {
      throw new Error('No purchase context prices available.');
    } else {
      console.error(
        `No matching purchase context found for '${context}'. Falling back to the first available context.`,
      );
      return fallback;
    }
  }
};

export const getSmallSizeItemPricesToggledByPurchaseContext = (
  show1xRxInSuf: boolean,
  purchaseContext: PurchaseContext,
  trialSizeItemPrices: ItemPrices,
  oneTimeItemPrices: ItemPrices,
) =>
  show1xRxInSuf && purchaseContext === 'onetime'
    ? { ...oneTimeItemPrices }
    : { ...trialSizeItemPrices };
